// extracted by mini-css-extract-plugin
export var iconWrapperStyle = "feature_grid_icon-module--iconWrapperStyle--fMtfy";